import { darken, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  formLogin: {
    display: 'flex',
    width: '100%',
  },
  leftButton: {
    borderRadius: '10px',
    fontSize: 21,
    fontWeight: 700,
    margin: `${theme.spacing(1.5)}px 0`,
    minWidth: '350px',

    '& .MuiTypography-root': {
      fontSize: 21,
      fontWeight: 700,
    },
  },
  textField: {
    margin: `${theme.spacing(1.5)}px 0`,
  },
  rightButton: {
    borderRadius: '10px',
    fontSize: 18,
    fontWeight: 700,
    margin: `${theme.spacing(1)}px 0`,
    minWidth: '275px',

    '& .MuiTypography-root': {
      fontSize: 18,
      fontWeight: 700,
    },
  },
  googleButton: {
    backgroundColor: theme.palette.tertiary.main,
    color: theme.palette.tertiary.contrastText,
    '&:hover': {
      backgroundColor: darken(theme.palette.tertiary.main, 0.2),
    },
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 300,
    paddingTop: '10px',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  loginContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    width: '100%',
  },
}));
